export function CmsMedia() {
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold text-text">Media Library</h1>
      <p className="text-text-muted">Manage images, banners, and media files here.</p>
    </div>
  )
}
